module.exports = __webpack_public_path__ + "media/sweepstakes_and_promotions/tip05_rollover-2521b79c.png";